import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { QuestionBlockComponent } from './question-block/question-block.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  standalone: true,
  selector: 'app-subtitle-block',
  templateUrl: './subtitle-block.component.html',
  styleUrls: ['./subtitle-block.component.css'],
  imports: [
    QuestionBlockComponent,
    ButtonModule,
    DividerModule,
    CommonModule,
    FormsModule
  ],
  animations: [
    trigger('fadeInOut', [
      state('void', style({
        opacity: 0,
      })),
      state('*', style({
        opacity: 1
      })),
      transition('void <=> *', animate(200)),
    ]),
  ],
})
export class SubtitleBlockComponent {

  @ViewChild('firstComponent') firstComponent!: QuestionBlockComponent
  @Input('first') first = false

  state = 'void'

  ngOnInit() {
    this.state = '*'
  }

  ngAfterViewInit() {
    this.questions.push(this.firstComponent)
  }

  subtitle = "Agregar subtítulo (opcional)"

  lod_subtitle = ""

  getText(input: string) {
    if(input) this.subtitle = ""
    else this.subtitle = "Agregar título (opcional)"
  }
  deleteTrim(text: string, input: HTMLInputElement) {
    text = text.trim()
    input.value = text
  }

  @Output('delete') delete = new EventEmitter<boolean>()
  deleteView() {
    this.delete.emit(true)
  }

  // Instancia del view container para generar los componentes
  @ViewChild('view', { read: ViewContainerRef }) viewContainer!: ViewContainerRef
  // Generamos el componente e instanciamos su observable para eliminarlo
  generate() {
    const component = this.viewContainer.createComponent(QuestionBlockComponent)
    component.instance.order = this.questions.length + 1
    this.questions.push(component.instance)
    component.instance.delete.asObservable().subscribe( () =>{
      this.questions = this.questions.filter(item => item != component.instance)
      component.destroy()
      let index = 1
      this.questions.forEach(i => {
        i.order = index
        index ++
      })
    })
  }

  // La instancia de todos los componentes
  questions: QuestionBlockComponent[] = []

}
